<template lang="pug">
  v-container(
    id="profile"
    class="profile-container"
  )
    v-card.cashback-container
      v-card-title
        b.header-title Earned Cashback
      v-card-text
        .cashback-body
          b RM
          em 10.00
      v-card-actions.pb-4
        v-btn.flex.mx-2(
          dense
          color="blue"
        ) Redeem
        v-btn.flex.mx-2(
          dense
          color="red"
        ) Withdraw
    v-card.cashback-history
      v-card-title
        b.header-title Cashback History
      v-card-text
        v-list(
          three-line
          flat
        )
          v-list-item-group(
            v-for="(s, index) in history_list"
            class="cashback-item"
            :key="s.order_id"
          )
            v-list-item-content.px-3
              v-list-item-title.border-bottom
                v-icon(
                  color="green"
                ) mdi-receipt
                b(
                  class="ml-2 my-auto"
                ) {{ s.order_id }}
            v-list-item
              template(v-slot:default="{ active }")
                v-list-item-content
                  v-list-item-title
                    b {{ s.merchant_name }}
                  v-list-item-subtitle {{ s.store_name }}
                v-list-item-action(
                  class="m-auto cashback-price"
                )
                  em + RM {{ s.cashback_earned }}
</template>

<script>
export default {
  data() {
    return {
      history_list: [
        {
          order_id: 18,
          merchant_name: "Oiyeesea",
          store_name: "Oiyeesea HQ",
          cashback_earned: "10.00"
        }
      ]
    };
  },
  methods: {}
};
</script>
